import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { CompanyFilterDataProviderFactory } from '../factory/CompanyFilterDataProviderFactory';
import { CompanyFilterBaseDataProvider } from '../dataProvider/CompanyFilterBaseDataProvider';
import { GetTargetsRequest, GetTargetsResponse } from '@nirvana/shared/dtos/types/alerts/gz-console';
import { GetCompaniesRequest, GetCompaniesResponse } from '@nirvana/shared/dtos/types/protected-entities/gz-console';

export class CompanyFilterRepository extends BaseWebComponentRepository {
  public dataProviderFactory: CompanyFilterDataProviderFactory;
  public dataProvider: CompanyFilterBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new CompanyFilterDataProviderFactory(),
    });
  }

  async getInitialTargets(request: GetTargetsRequest): Promise<GetTargetsResponse | undefined> {
    return await this.dataProvider.getInitialTargets(request);
  }

  async getCompanies(request: GetCompaniesRequest): Promise<GetCompaniesResponse | undefined> {
    return await this.dataProvider.getCompanies(request);
  }
}
